import ImgItem from "gatsby-theme-dettol/src/components/common/MediaInfoBox/ImgItem/ImgItem"

import "./ImgItemOverride.scss"

export default ImgItem